import { action, makeObservable, observable, runInAction } from 'mobx';
import { ILookup, LookupValue, LookupValueId, LookupValueSelectListener } from './lookup/ILookup';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { IComponentProductData, IComponentTextData, IProductComponent } from '@canvas-logic/clp-domain';

let id = 0;
// TODO: rewrite
export class ComponentLookup implements ILookup<boolean> {
  public readonly id = 'component-lookup-' + ++id;
  values: LookupValue<boolean>[] = [];
  current: LookupValue<boolean> = null as any;
  productData: IComponentProductData[] = [];
  loading = false;
  texts: IComponentTextData;
  componentSchema: IProductComponent | null = null;
  private valueSelectListener?: LookupValueSelectListener<boolean>;

  get componentVariant() {
    return this.api.getComponentVariant(this.componentKey);
  }

  constructor(private readonly api: ICompositeProductApi, public readonly componentKey: string) {
    makeObservable(this, {
      select: action.bound,
      updateValues: action.bound,
      updateCurrent: action.bound,
      values: observable,
      loading: observable,
      current: observable,
      componentSchema: observable,
    });
    const initialValue = this.api.isAvailable(this.componentKey);
    this.values = [
      {
        id: '0',
        value: initialValue,
      },
    ];

    this.productData = this.api.getComponentAllProducts(this.componentKey);
    this.texts = this.api.getComponentTextData(this.componentKey);
    this.componentSchema = this.api.getComponentSchema(this.componentKey);
    this.updateValues();
  }

  isEnable() {
    return this.api.isEnable(this.componentKey);
  }

  select(id: LookupValueId) {
    const item = this.values.find((it) => it.id === id);
    if (item === undefined) {
      throw new Error('Unexpected lookup value id');
    }
    const value = item.value;
    this.api
      .setAvailability(this.componentKey, value)
      .then(() => this.updateValues())
      .then(() => {
        this.updateCurrent();
        if (this.valueSelectListener) {
          this.valueSelectListener(value);
        }
      });
  }

  async updateValues() {
    this.loading = true;
    const values = (await this.api.loadAvailability(this.componentKey)) ?? [];
    runInAction(() => {
      this.values = values.map((value, index: number) => {
        return {
          id: index.toString(),
          value: value,
        };
      });

      this.productData = this.api.getComponentAllProducts(this.componentKey);
      this.updateCurrent();
      this.loading = false;
    });
  }

  setValueSelectListener(listener: LookupValueSelectListener<boolean>) {
    this.valueSelectListener = listener;
  }

  updateCurrent() {
    const isAvailable = this.api.isAvailable(this.componentKey);
    const current = this.values.find((item) => isAvailable === item.value);
    if (current === undefined) {
      throw new Error('Unexpected model property value');
    }
    this.current = current;
  }
}
